export default __webpack_public_path__ + "static/media/4.ed3b1a69.jpg";